// extracted by mini-css-extract-plugin
export default {"procedureColumn":"procedureColumn_procedureColumn__vqu0m","titleBlock":"procedureColumn_titleBlock__DXzG0","contentBlock":"procedureColumn_contentBlock__LuEFC"};